"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefillContextProvider = exports.PrefillContextConsumer = exports.usePrefillContext = void 0;
var react_1 = __importStar(require("react"));
var pages_common_1 = require("@qwilr/pages-common");
var axios_1 = __importDefault(require("axios"));
var mobx_react_1 = require("mobx-react");
var PrefillContext = react_1.default.createContext(undefined);
var usePrefillContext = function () {
    var context = react_1.default.useContext(PrefillContext);
    if (!context) {
        throw new Error("usePrefillContext() must be used within a <PrefillContextProvider> component");
    }
    return context;
};
exports.usePrefillContext = usePrefillContext;
exports.PrefillContextConsumer = (0, mobx_react_1.observer)(function (_a) {
    var children = _a.children;
    var context = (0, react_1.useContext)(PrefillContext);
    if (!context) {
        throw new Error("PrefillContextConsumer must be used within a <PrefillContextProvider> component");
    }
    return children(context);
});
var PrefillContextProvider = function (_a) {
    var children = _a.children, consumerDataServiceBaseUrl = _a.consumerDataServiceBaseUrl, esignEnabled = _a.esignEnabled, sellerHasSetName = _a.sellerHasSetName, acceptTelemetry = _a.acceptTelemetry;
    var _b = (0, pages_common_1.useAuthenticationContext)(), isSignedIn = _b.isSignedIn, getToken = _b.getToken, user = _b.user;
    var _c = __read((0, react_1.useState)(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read((0, react_1.useState)(undefined), 2), prefill = _d[0], setPrefill = _d[1];
    var removeField = function (fieldName) {
        var data = __assign({}, prefill);
        data[fieldName] = undefined;
        setPrefill(data);
        if (fieldName === "signature") {
            pages_common_1.PubSub.publish("qwilr:prefilled-signature-changed", { signature: undefined });
        }
    };
    (0, react_1.useEffect)(function () {
        var setFallbackState = function () {
            setPrefill(undefined);
            pages_common_1.PubSub.publish("qwilr:prefilled-signature-changed", { signature: undefined });
        };
        if (isSignedIn && !!user) {
            var fetchAndCachePrefillData = function () { return __awaiter(void 0, void 0, void 0, function () {
                var token, prefillFromCDS, signature, prefillData;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            setLoading(true);
                            return [4, getToken()];
                        case 1:
                            token = _d.sent();
                            if (!token) {
                                throw new Error("Could not retrieve auth token for fetching prefill details");
                            }
                            return [4, fetchPrefillData(consumerDataServiceBaseUrl, token)];
                        case 2:
                            prefillFromCDS = _d.sent();
                            signature = undefined;
                            prefillData = undefined;
                            if (!prefillFromCDS) return [3, 5];
                            if (!(esignEnabled && prefillFromCDS.signature)) return [3, 4];
                            return [4, fetchSignatureData(token, prefillFromCDS.signature)];
                        case 3:
                            signature = _d.sent();
                            _d.label = 4;
                        case 4:
                            prefillData = {
                                organisation: prefillFromCDS.organisation,
                                signature: signature !== null && signature !== void 0 ? signature : undefined,
                                legalName: sellerHasSetName ? undefined : (_a = prefillFromCDS.legalName) !== null && _a !== void 0 ? _a : user.fullName,
                                email: (_b = user.emailAddress) !== null && _b !== void 0 ? _b : "",
                            };
                            return [3, 6];
                        case 5:
                            prefillData = {
                                email: (_c = user.emailAddress) !== null && _c !== void 0 ? _c : "",
                                legalName: sellerHasSetName ? undefined : user.fullName,
                            };
                            pages_common_1.PubSub.publish("qwilr:prefill-not-found", { user: true, hasSavedPrefillData: false });
                            _d.label = 6;
                        case 6:
                            pages_common_1.PubSub.publish("qwilr:prefilled-signature-changed", { signature: signature });
                            setPrefill(prefillData);
                            return [2];
                    }
                });
            }); };
            fetchAndCachePrefillData()
                .catch(function (err) {
                console.log("Failed to fetch user prefill data", err);
                setFallbackState();
            })
                .finally(function () {
                setLoading(false);
            });
        }
        else {
            pages_common_1.PubSub.publish("qwilr:prefill-not-found", { user: false, hasSavedPrefillData: false });
            setFallbackState();
            setLoading(false);
        }
    }, [consumerDataServiceBaseUrl, getToken, isSignedIn, user, esignEnabled, sellerHasSetName]);
    return (react_1.default.createElement(PrefillContext.Provider, { value: { loading: loading, prefill: prefill, removeField: removeField, acceptTelemetry: acceptTelemetry } }, children));
};
exports.PrefillContextProvider = PrefillContextProvider;
var fetchPrefillData = function (baseUrl, token) { return __awaiter(void 0, void 0, Promise, function () {
    var axiosInstance, clerkAuthHeader, response, error_1, err;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                axiosInstance = axios_1.default.create({
                    baseURL: baseUrl,
                    withCredentials: false,
                });
                clerkAuthHeader = {
                    Authorization: "Bearer ".concat(token),
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, axiosInstance.get("/prefill", {
                        headers: clerkAuthHeader,
                    })];
            case 2:
                response = _b.sent();
                return [2, response.data];
            case 3:
                error_1 = _b.sent();
                err = error_1;
                if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    return [2, undefined];
                }
                console.error("Error retrieving prefill data for springboard user", error_1);
                return [2, undefined];
            case 4: return [2];
        }
    });
}); };
var fetchSignatureData = function (token, signatureFetchUrl) { return __awaiter(void 0, void 0, Promise, function () {
    var axiosInstance, clerkAuthHeader, response, base64Encoded, error_2, err;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                axiosInstance = axios_1.default.create({
                    withCredentials: false,
                });
                clerkAuthHeader = {
                    Authorization: "Bearer ".concat(token),
                };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4, axiosInstance.get(signatureFetchUrl, {
                        headers: clerkAuthHeader,
                        responseType: "arraybuffer",
                    })];
            case 2:
                response = _b.sent();
                return [4, arrayBufferToBase64(response.data)];
            case 3:
                base64Encoded = _b.sent();
                return [2, base64Encoded];
            case 4:
                error_2 = _b.sent();
                err = error_2;
                if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    return [2, undefined];
                }
                console.error("Error retrieving prefill signature for springboard user", error_2);
                return [2, undefined];
            case 5: return [2];
        }
    });
}); };
var arrayBufferToBase64 = function (arrayBuffer) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve) {
                var blob = new Blob([arrayBuffer]);
                var reader = new FileReader();
                reader.onload = function (event) {
                    var _a;
                    if (!((_a = event.target) === null || _a === void 0 ? void 0 : _a.result)) {
                        return resolve("");
                    }
                    var dataUrl = event.target.result;
                    var _b = __read(dataUrl.split(","), 2), _ = _b[0], base64 = _b[1];
                    resolve(base64);
                };
                reader.readAsDataURL(blob);
            })];
    });
}); };
